import React from 'react'
import PropTypes from 'prop-types'
import { navigate } from '@reach/router'
import { Box, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { get } from 'lodash'
import * as Accessa from 'accessa'
import BlogCategorySelect from './BlogCategorySelect'
import ArchivePagination from './ArchivePagination'

export const getFirstDefinedImage = (categories) =>
  Array.isArray(categories)
    ? categories.find((c) =>
        Boolean(get(c, 'featuredImage.fluid'))
      )?.featuredImage?.fluid
    : ''

export const toFeaturePropsShape = (xs = []) =>
  xs.map(
    ({
      title,
      name,
      relativePath,
      image = {},
      categories = [],
    }) => ({
      fluid:
        get(image, 'fluid') ||
        getFirstDefinedImage(categories),
      onClick: () => navigate(relativePath),
      title: title || name,
    })
  )

const useStyles = makeStyles(({ breakpoints }) => ({
  container: {
    [breakpoints.down('sm')]: {
      paddingLeft: '2.5rem',
      paddingRight: '2.5rem',
    },
  },
}))

const ArchiveLayoutBlogs = ({ data }) => {
  const {
    allContentfulBlog: { pageInfo, nodes },
    contentfulArchive,
    perPage,
  } = data
  const { container } = useStyles()

  return (
    <Box pt={5} pb={5}>
      <Accessa.Headers.Mast
        title={contentfulArchive.hero.title}
        fluid={contentfulArchive.hero.image.fluid}
      />
      <Box mt={5}>
        <Container className={container}>
          <BlogCategorySelect />
          <Accessa.Features.Field
            lists={toFeaturePropsShape(nodes)}
          />
          <ArchivePagination
            {...contentfulArchive}
            pageInfo={pageInfo}
            perPage={perPage}
          />
        </Container>
      </Box>
    </Box>
  )
}

ArchiveLayoutBlogs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
}

export default ArchiveLayoutBlogs
